<template>
  <div>
    <div class="form-group">
      <label for="">Detalle de tarea</label>
      <input type="text" class="form-control" v-model="bodyForm.note" />
    </div>
    <div class="form-group">
      <label for="">Fecha </label>
      <app-datepicker v-model="bodyForm.date_to_contact"></app-datepicker>
    </div>
    <div class="form-group">
      <label for="">Paciente</label>
      <SelectClient ref="selCli" v-model="bodyForm.client_id"></SelectClient>
    </div>
    <div class="form-group">
      <label for="">Tipo</label>
      <SelectType v-model="bodyForm.type_id"></SelectType>
    </div>
    <app-button-submit @click="save()" :disabled="sending"></app-button-submit>
  </div>
</template>
<script>
import SelectClient from "../../store-module/clients/Select";
import { ServiceFactory } from "../../service-module/service";
import SelectType from "./SelectType";
import { myMoment } from "../../utils/myMoment";

export default {
  components: {
    SelectClient,
    SelectType
  },

  // directives
  // filters

  props: {
    clientId: {},
    quote_id: {},
  },

  data: () => ({
    bodyForm: {
      client_id: null,
      date_to_contact: null,
      note: "",
      type_id: 1
    },
    sending: false,
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  mounted() {
    this.reset();
  },

  methods: {
    reset() {
      this.$refs.selCli.reset();
      this.bodyForm.client_id = this.clientId || null;
      this.bodyForm.date_to_contact = myMoment().format("YYYY-MM-DD");
      this.bodyForm.note = null;
      this.bodyForm.type_id = 1;

      if (this.quote_id) {
        this.bodyForm.quote_id = this.quote_id;
      }
      if (this.clientId) {
        this.$refs.selCli.setValueFromId(this.clientId);
      }
    },
    async save() {
      this.sending = true;
      let res = await ServiceFactory.saveContactTask(this.bodyForm);
      this.$emit("saved", res);
      this.sending = false;
    }
  }
};
</script>

<style></style>
